// extracted by mini-css-extract-plugin
export default {"Layout":"styles_Layout__zIfpA","wrapper":"styles_wrapper__U2lMb"};